import { isMobile } from 'react-device-detect';
import * as commonProxy from 'libs/CommonProxy';
import * as main from 'pages/web/frame/WithInfoMain';
import * as mMain from 'pages/mobile/frame/WithInfoMain';
import { store } from '../redux/store';
import { FrameAction, IOpenPageOrPopupArgs } from '../redux/slice/frame/root_main_slice';

export const editorKey = 'cosbltyzhtofq8o3v3frsigxwnf32x1ucelysuv4l0c4de5e';

const decodeJwtToken = (token:string) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}


/**
 * <p>빈문자열 여부.</p>
 * @param sVal - 문자열
 * @return boolean
 */
const isEmptyString = (sVal:string) => {
	return !sVal;
}

/**
 * <p>문자열을 오른쪽에서 nSize만큼 자른 후 리턴.</p>
 * @param sOrg - 원본 문자열
 * @param nSize -자를 Size
 * @return string (자른 후 문자열)
 */
 const getRightString = (sOrg:string, nSize:number) => {
	if(!sOrg || !nSize)	return '';
	
	if(sOrg.length < nSize)
		return sOrg;
	else
		return sOrg.substring(sOrg.length-nSize, nSize);
}
/**
 * <p>문자열을 왼쪽에서 nSize만큼 자른 후 리턴.</p>
 * @param sOrg - 원본 문자열
 * @param nSize -자를 Size
 * @return string (자른 후 문자열)
 */
const getLeftString = (sOrg:string, nSize:number) => {
	if(!sOrg || !nSize)	return '';
	
	if(sOrg.length < nSize)
		return sOrg;
	else
		return sOrg.substring(0, nSize);
}

/**
 * 좌측문자열채우기
 * @params
 *  - str : 원 문자열
 *  - padLen : 최대 채우고자 하는 길이
 *  - padStr : 채우고자하는 문자(char)
 */
 export function lpad(str:string, padLen:number, padStr:string) {
    if (padStr.length > padLen) {
        return str;
    }
    str += ""; // 문자로
    padStr += ""; // 문자로
    while (str.length < padLen)
        str = padStr + str;
    str = str.length >= padLen ? str.substring(0, padLen) : str;
    return str;
}

/**
 * <p>임시비밀번호여부</p>
 * @param 
 * @param 
 * @return
 */
const isUserTempPswdYn = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.tempPswdYn;
}

/**
 * <p>사용자상태</p>
 * @param 
 * @param 
 * @return
 */
const getUserStCd = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.userStCd;
}

/**
 * <p>관리자여부</p>
 * @param 
 * @param 
 * @return
 */
const isAdmin = () => {
    const  decodeToken  = decodeJwtToken(localStorage.getItem('jwtToken'));
    const  authrtyId    = decodeToken.authrtyId;
    const  arrAuthrtyId = authrtyId.split(',');
    return arrAuthrtyId ? arrAuthrtyId.includes('004202300002') || arrAuthrtyId.includes('004202300003') : false;
}

/**
 * <p>사용자유형</p>
 * @param 
 * @param 
 * @return
 */
const getUserTpCd = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.userTpCd;
}


/**
 * <p>사용자ID 얻기</p>
 * @param 
 * @param 
 * @return
 */
 const getUserId = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.userId;
}

/**
 * <p>사원번호 얻기</p>
 * @param 
 * @param 
 * @return
 */
const getEmpNo = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.empNo;
}

/**
 * <p>사용자명  얻기</p>
 * @param 
 * @param 
 * @return
 */
 const getUserNm = () => {
    const  decodeToken = localStorage.getItem('jwtToken') ? decodeJwtToken(localStorage.getItem('jwtToken')) : {userNm : ""};
    return decodeToken.userNm;
}

/**
 * <p>부서코드 얻기</p>
 * @param 
 * @param 
 * @return
 */
 const getDeptCd = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.deptCd;
}

/**
 * <p>부서코드 얻기</p>
 * @param 
 * @param 
 * @return
 */
 const isDeptHdr = () => {
    const  decodeToken = decodeJwtToken(localStorage.getItem('jwtToken'));
    return decodeToken.deptHdrYn === 'Y';
}

/**
 * <p>공통헤더정보 얻기</p>
 * @param 
 * @param 
 * @return
 */
 const getHeader = (txCd:string) => {
    const decodeToken = localStorage.getItem('jwtToken') ? decodeJwtToken(localStorage.getItem('jwtToken')) : null;
    const header = {
        instCd      : decodeToken ? decodeToken.instCd : txCd === 'TRUSRR0001' ? '002' : '000',
        txCd        : txCd,
        txChnlCd    : '01',
        sessionId   : localStorage.getItem('sessionId'),
        scrnId      : localStorage.getItem('scrnId'),
    };

    return header;
}


/**
 * <p>코드그룹 조회</p>
 * @param 
 * @param 
 * @return
 */
 const getComCodeList = (cdGrpId:string, option:any) => {
    /* 변수선언 및 셋팅 영역 */
    const requestData = {
        cdGrpId : cdGrpId,                         // 코드그룹ID
        useYn: !option.useYn ? '' : option.useYn
    };
      
    let datas = null;
    /* 트렌젝션 호출 및 결과 셋팅 */
    commonProxy.callAsyncSvc(requestData, {
        txCd : 'TRCOMR0001',
        noLoading : true,
        success : (responseData:any) => {
            datas = responseData;
            typeof option.callback === 'function' && option.callback(datas.codeItems);
        },
    });
}


/**
 * <p>페이지 오픈</p>
 * @param 
 * @param 
 * @return
 */
const openPage = (item:IOpenPageOrPopupArgs) => {
    const rootState = store.getState();
    const allLnbMenuItems = rootState.Frame.allLnbMenuItems;
    const topMenuItems    = rootState.Frame.topMenuItems;
    const activeKey       = rootState.Frame.activeKey;

    item.props = {
        ...item.props,
        opener : activeKey
    };

    const leftMenu:any = allLnbMenuItems.filter((left:any) => {
        return left.key === item.menuId;
    })[0];
    const topMenu:any = topMenuItems.filter((top:any) => {
        return top.menuId === leftMenu.upperMenuId;
    })[0];

    setCurrLeftMenuClick({ ...topMenu, key : topMenu.menuId });

    store.dispatch(FrameAction.setMenuPath(topMenu.menuNm + ' > ' + leftMenu.title));
    store.dispatch(FrameAction.setActiveProps(item.props));
    store.dispatch(FrameAction.setMdiItems([item.menuId] as any));
    store.dispatch(FrameAction.setActiveKey(item.menuId));
}


/**
 * <p>TOP메뉴 클릭</p>
 * @param 
 * @param 
 * @return
 */
 const setCurrLeftMenuClick = (top:any) => {
    const rootState = store.getState();
    const allLnbMenuItems = rootState.Frame.allLnbMenuItems;

    const currLnbMenuItems = allLnbMenuItems.filter((lnb:any) =>{
        return lnb.upperMenuId === top.key && lnb.key !== 'MCOM2021008';
    });

    store.dispatch(FrameAction.setLnbMenuItems(currLnbMenuItems as []));
    store.dispatch(FrameAction.setCurrentTopMenuKey(top.key));
}

/**
 * <p>메시지</p>
 * @param 
 * @param 
 * @return
 */
const setMsgItem = (params:any) => {
    store.dispatch(FrameAction.setMsgItem(params));
    store.dispatch(FrameAction.setIsOpenPopup(true));
}

/**
 * <p>로딩바</p>
 * @param 
 * @param 
 * @return
 */
 const showLoading = (showLoading:boolean) => {
    if (!showLoading) {
        store.dispatch(FrameAction.setShowLoading(showLoading));
    } else {
        store.dispatch(FrameAction.setShowLoading(showLoading));
    }
}

/**
 * <p>팝업오픈</p>
 * @param 
 * @param 
 * @return
 */
const openPopup = (params:IOpenPageOrPopupArgs) => {
    params = { ...params, openerId : localStorage.getItem('scrnId') };
    localStorage.setItem('scrnId', params.popupId);
    if (!isMobile) {
        main.openPopup(params);
    } else {
        mMain.openPopup(params);
    }
}

/**
 * <p>팝업닫기</p>
 * @param 
 * @param 
 * @return
 */
 const closeAllPopup = () => {
    if (!isMobile) {
        main.closeAllPopup();
    } else {
        mMain.closeAllPopup();
    }
}

/**
 * <p>로그아웃</p>
 * @param 
 * @param 
 * @return
 */
const logout = () => {
    store.dispatch(FrameAction.setJwtToken(''));
}

/**
 * <p>Alert</p>
 * @param 
 * @param 
 * @return
 */
 const openAlert = (params:any) => {
    setMsgItem({...params, type: 'alert'});
}

/**
 * <p>Info</p>
 * @param 
 * @param 
 * @return
 */
 const openInfo = (params:any) => {
    setMsgItem({...params, type: 'info'});
}

/**
 * <p>Confirm</p>
 * @param 
 * @param 
 * @return
 */
 const openConfirm = (params:any) => {
    setMsgItem({...params, type: 'confirm'});
}

/**
 * <p>openError</p>
 * @param 
 * @param 
 * @return
 */
 const openError = (params:any) => {
    setMsgItem({...params, type: 'error'});
}

const getReadonlySelectboxProps = (isReadOnly:boolean) => {
    const props:any = {};
    if (isReadOnly) {
        props.defaultOpen = false;
        props.open = false;
    }

    return props;
}

/**
 * <p>파일 업로드</p>
 * @param 
 * @param 
 * @return
 */
 const uploadFile = (files:any[], options:any) => {
    /* 변수선언 및 셋팅 영역 */
    const contentType = {'content-type': 'multipart/form-data'};
    let requestData = new FormData();

    for (let i = 0; i < files.length; i++) {
        requestData.append('files', files[i]);
    }
    requestData.append('sourceDcd', options.sourceDcd);
    requestData.append('sourceId' , options.sourceId);

    /* 트렌젝션 호출 및 결과 셋팅 */
    commonProxy.callAsyncSvc(requestData, {
        txCd : 'TRFRMR0003',
        ...contentType,
        success: (responseData:any) => {
            if(typeof options.success === "function"){
                options.success(responseData);
            }
        },
    });
}

/**
 * 기능 : 파일다운로드
 * 설명 : 
 * param : 
 * return : None
 */
 const downloadFile = (fileId:any) => {
    /* 변수선언 및 셋팅 영역 */
    const requestData = { id : fileId };

    /* 트렌젝션 호출 및 결과 셋팅 */
    commonProxy.callAsyncSvc(requestData, {
        responseType : 'blob',
        txCd : 'TRFRMR0004',
        success: (responseData:any) => {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(responseData.headers['content-disposition'])
            const fileName = matches[1].replaceAll('"', '')

            const bLobUrl = new Blob([responseData.data], { type: 'blob' });
            const url = window.URL.createObjectURL(bLobUrl);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(JSON.stringify(bLobUrl));
        },
    });
}

/**
 * <p>인사관리자여부</p>
 * @param 
 * @param 
 * @return
 */
const isHrAdmin = () => {
    const  decodeToken  = decodeJwtToken(localStorage.getItem('jwtToken'));
    const  authrtyId    = decodeToken.authrtyId;
    const  arrAuthrtyId = authrtyId.split(',');
    return arrAuthrtyId ? arrAuthrtyId.includes('004202600001') : false;
}

export {
    isEmptyString,
    getRightString,
    getLeftString,
    isUserTempPswdYn,
    getUserStCd,
    isAdmin,
    isDeptHdr,
    getUserTpCd,
    getUserId,
    getEmpNo,
    getUserNm,
    getDeptCd,
    getHeader,
    getComCodeList,
    openPage,
    showLoading,
    openPopup,
    closeAllPopup,
    openAlert,
    openInfo,
    openConfirm,
    openError,
    getReadonlySelectboxProps,
    uploadFile,
    downloadFile,
    logout,
    setCurrLeftMenuClick,
    isHrAdmin     // 인사관리자 여부 추가
}

